import { IChildProp } from '@intelligence/components/Form/type';

const SREAMING_INFLUENCER_MORE: IChildProp[] = [{
  enumKey: 'platform',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  children: [{
    enumKey: 'twitch',
    enumTargetType: 'platformStreaming',
    defaultSelectCondition: 'additionalFields:platforms:[]twitch',
  }, {
    enumKey: 'youtube',
    enumTargetType: 'platformStreaming',
    defaultSelectCondition: 'additionalFields:platforms:[]ytg',
  }, {
    enumKey: 'facebookGaming',
    enumTargetType: 'platformStreaming',
    defaultSelectCondition: 'additionalFields:platforms:[]facebook',
  }]
}, {
  enumKey: 'metrics',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  children: [
    {
      enumKey: 'hoursWatched',
      enumTargetType: 'metric',
      isNoIcon: true,
      isDefault: true,
    },
    {
      // TODO: value拼写错误，待沟通
      enumKey: 'peakCCVWrong',
      enumTargetType: 'metric',
      isNoIcon: true,
      isDefault: true,
    },
    {
      enumKey: 'avgCCV',
      enumTargetType: 'metric',
      isNoIcon: true,
      isDefault: true,
    },
    {
      enumKey: 'airtimeSimple',
      enumTargetType: 'metric',
      isNoIcon: true,
      isDefault: true,
    }
  ]
}, {
  enumKey: 'basicInformation',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  children: [{
    enumKey: 'hasLanguage',
    enumTargetType: 'downloadBasicInfo',
    isDefault: true,
    condition: 'additionalFields:businessType:streaming-anchors-more',
  }, {
    enumKey: 'hasUrl',
    enumTargetType: 'downloadBasicInfo',
    isDefault: true,
    condition: 'additionalFields:businessType:streaming-anchors-more',
  }, {
    enumKey: 'hasCompany',
    enumTargetType: 'downloadBasicInfo',
    condition: 'additionalFields:businessType:streaming-games-top',
  }, {
    enumKey: 'hasGenre',
    enumTargetType: 'downloadBasicInfo',
    condition: 'additionalFields:businessType:streaming-games-top',
  }, {
    enumKey: 'hasRelease',
    enumTargetType: 'downloadBasicInfo',
    condition: 'additionalFields:businessType:streaming-games-top',
  }, {
    enumKey: 'hasGameType',
    enumTargetType: 'downloadBasicInfo',
    condition: 'additionalFields:businessType:streaming-games-top',
  }],
}, {
  enumKey: 'dataCalculation',
  enumTargetType: 'downloadMainCategory',
  type: 'subForm',
  className: 'form-item--top-18',
  children: [{
    enumKey: 'editionSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'text',
    children: [{
      enumKey: 'isEditionAggregated',
      enumTargetType: 'downloadDataCalcu',
    }]
  }, {
    enumKey: 'timeSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'isTimeAggregated',
      enumTargetType: 'downloadDataCalcu',
    }, {
      enumKey: 'isSeparateByTime',
      enumTargetType: 'downloadDataCalcu',
    }]
  }, {
    enumKey: 'platformSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    condition: 'additionalFields:businessType:streaming-games-top',
    children: [{
      isDefault: true,
      enumKey: 'isPlatformAggregated',
      enumTargetType: 'downloadDataCalcu',
    }, {
      enumKey: 'isByPlatform',
      enumTargetType: 'downloadDataCalcu',
    }]
  }, {
    enumKey: 'anchorsSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    condition: 'additionalFields:businessType:streaming-games-top',
    children: [{
      isDefault: true,
      enumKey: 'isAnchorsAggregated',
      enumTargetType: 'downloadDataCalcu',
    }, {
      enumKey: 'isShowTopInfluencers',
      enumTargetType: 'downloadDataCalcu',
    }]
  }, {
    enumKey: 'gameSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    condition: 'additionalFields:businessType:streaming-anchors-more',
    children: [{
      isDefault: true,
      enumKey: 'isGamesAggregated',
      enumTargetType: 'downloadDataCalcu',
    }, {
      enumKey: 'isByGames',
      enumTargetType: 'downloadDataCalcu',
    }]
  },{
    enumKey: 'ratio',
    enumTargetType: 'downloadMainCategory',
    type: 'switch',
    isDefault: true,
  }]
}, {
  enumKey: 'dataAmount',
  enumTargetType: 'downloadMainCategory',
  type: 'radio',
  children: [{
    isDefault: true,
    enumKey: 'exportAllData',
    enumTargetType: 'downloadOther',
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadOther',
  }, {
    enumKey: 'exportSpecialSelected',
    enumTargetType: 'downloadOther',
  }]
}, {
  enumKey: 'selectTop',
  enumTargetType: 'downloadMainCategory',
  type: 'inputNumber',
  // 默认值，带?为变量传入，不带为正常值
  defaultValue: '?additionalFields:initialSelectTop',
  condition: 'dataAmount:top',
}, {
  enumKey: 'fileFormat',
  enumTargetType: 'downloadMainCategory',
  type: 'radio',
  children: [{
    isDefault: true,
    enumKey: 'exportExcel',
    enumTargetType: 'downloadOther',
  }, {
    enumKey: 'exportCSV',
    enumTargetType: 'downloadOther',
  }],
}];

export default {
  streamingInfluencer: SREAMING_INFLUENCER_MORE,
};
